var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "view-point-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            {
              staticStyle: {
                display: "flex",
                "align-items": "flex-end",
                gap: "0 8px",
              },
              attrs: { "label-position": "left" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "通知類型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇通知類型",
                      },
                      model: {
                        value: _vm.listQuery.fcmType,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "fcmType", $$v)
                        },
                        expression: "listQuery.fcmType",
                      },
                    },
                    _vm._l(_vm.fcmTypeOption, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.val, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getList } },
                    [_vm._v("查詢")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.listLoading,
                      type: "success",
                      icon: "el-icon-refresh-left",
                      circle: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [_c("NotificationSetting", { attrs: { type: "ita" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "資料ID", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "推播時間", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { effect: "dark", type: "success" } },
                          [_vm._v(_vm._s(scope.row.recordDate))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "旅遊團", width: "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.travelID
                          ? _c("span", [
                              _vm._v(
                                "(ID:" +
                                  _vm._s(scope.row.travelID) +
                                  ")" +
                                  _vm._s(scope.row.travelName)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "使用者名稱", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.userName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "Tokens", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.tokenList,
                        function (item, index) {
                          return _c(
                            "el-popover",
                            {
                              key: index,
                              attrs: {
                                placement: "top-start",
                                title: "Token " + (index + 1),
                                width: "200",
                                trigger: "hover",
                                content: item,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [_vm._v(_vm._s("Token " + (index + 1)))]
                              ),
                            ],
                            1
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "傳送類型", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              effect: "dark",
                              type:
                                _vm.fcmTypeTransfer(scope.row.fcmType) % 2 == 0
                                  ? "success"
                                  : "",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.fcmTypeDesc))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "傳送內容", width: "450" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { effect: "dark", type: "info" } },
                          [_vm._v(_vm._s(scope.row.content))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "成功筆數", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.successCount == 0
                          ? _c("span")
                          : _c(
                              "el-tag",
                              { attrs: { effect: "dark", type: "success" } },
                              [_vm._v(_vm._s(scope.row.successCount))]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "失敗筆數", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.failureCount == 0
                          ? _c("span")
                          : _c(
                              "el-tag",
                              { attrs: { effect: "dark", type: "danger" } },
                              [_vm._v(_vm._s(scope.row.failureCount))]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "MessageID", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.messageId))])]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }